import { render, staticRenderFns } from "./RefundConfigForm.vue?vue&type=template&id=01fca0d8&scoped=true&"
import script from "./RefundConfigForm.vue?vue&type=script&lang=ts&"
export * from "./RefundConfigForm.vue?vue&type=script&lang=ts&"
import style0 from "./RefundConfigForm.vue?vue&type=style&index=0&id=01fca0d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fca0d8",
  null
  
)

export default component.exports